export const dropdownMenuItemSelector = '[role="menuitem"]';

export function getDropdownMenuItems(container: ParentNode, selector = dropdownMenuItemSelector): HTMLElement[] {
  return Array.from(container.querySelectorAll<HTMLElement>(selector));
}

export function focusDropdownMenuItem(items: HTMLElement[], focusLastItem: boolean): void {
  const item = focusLastItem ? items[items.length - 1] : items[0];
  item?.focus();
}

export function focusDropdownMenuItemAsync(container: ParentNode, focusLastItem: boolean, selector = dropdownMenuItemSelector): void {
  setTimeout(() => {
    focusDropdownMenuItem(getDropdownMenuItems(container, selector), focusLastItem);
  });
}

export function showDropdownAndFocusMenuItem(
  event: KeyboardEvent,
  showMenu: () => void,
  focusLastItem: boolean,
  selector = dropdownMenuItemSelector): void {
  event.preventDefault();
  showMenu();
  const toggleButton = event.currentTarget as HTMLElement;
  focusDropdownMenuItemAsync(toggleButton.parentElement ?? toggleButton, focusLastItem, selector);
}

export function handleDropdownMenuKeydown(
  event: KeyboardEvent,
  items: HTMLElement[],
  closeMenu: () => void,
  toggleButton?: HTMLElement,
  selector = dropdownMenuItemSelector): void {
  if (!items.length) {
    return;
  }

  const currentItem = (event.target as Element).closest<HTMLElement>(selector);
  const index = currentItem ? items.indexOf(currentItem) : -1;
  if (event.key === 'ArrowDown') {
    event.preventDefault();
    items[index === -1 ? 0 : (index + 1) % items.length]?.focus();
  }
  else if (event.key === 'ArrowUp') {
    event.preventDefault();
    items[index === -1 ? items.length - 1 : (index - 1 + items.length) % items.length]?.focus();
  }
  else if ((event.key === 'Enter' || event.key === ' ') && currentItem) {
    event.preventDefault();
    currentItem.click();
  }
  else if (event.key === 'Escape') {
    event.preventDefault();
    closeMenu();
    toggleButton?.focus();
  }
}

export function handleDropdownMenuContainerKeydown(
  event: KeyboardEvent,
  closeMenu: () => void,
  toggleButton?: HTMLElement,
  selector = dropdownMenuItemSelector): void {
  handleDropdownMenuKeydown(event, getDropdownMenuItems(event.currentTarget as Element, selector), closeMenu, toggleButton, selector);
}

export function configureDropdownMenuRoles(container: HTMLElement): void {
  getDropdownMenuItems(container, '[role="menuitem"], .menu-item').forEach((item) => {
    item.setAttribute('role', 'menuitem');
    item.setAttribute('tabindex', '0');
  });

  Array.from(container.querySelectorAll<HTMLElement>('.dropdown-divider')).forEach((sep) => {
    sep.setAttribute('role', 'separator');
  });
}
